import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[rosieStackCard]',
  standalone: false
})
export class StackCardDirective {
  @Input() rosieStackCardId: string;
  @Input() rosieStackCardDismissible = false;
  @Input() rosieStackCardVisible = true;

  constructor(public templateRef: TemplateRef<any>) {}
}
